import { render, staticRenderFns } from "./EditAccountDetailPage.vue?vue&type=template&id=3d5a8900&scoped=true"
import script from "./EditAccountDetailPage.vue?vue&type=script&lang=js"
export * from "./EditAccountDetailPage.vue?vue&type=script&lang=js"
import style0 from "./EditAccountDetailPage.vue?vue&type=style&index=0&id=3d5a8900&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5a8900",
  null
  
)

export default component.exports